module.exports = __webpack_public_path__ + "static/media/Login-Background.79a861d4.jpg";